module.exports = __webpack_public_path__ + "static/media/drivers.50ce3dae.svg";